import { FC, useContext } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContextSemPaginacao,
  initialQueryResponseSemPaginacao,
  QUERIES,
  showError,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useParametrosIndicadores } from './QueryRequestProvider'
import { IndicadoresPerformance, ParametrosIndicadores } from './_models'
import { getIndicadoresPerformance } from './_requests'

const QueryResponsePerformanceContext = createResponseContextSemPaginacao<IndicadoresPerformance>(
  initialQueryResponseSemPaginacao
)

/** Montado só dentro da aba Performance: a request existe apenas enquanto a aba está na tela. */
export const QueryResponsePerformanceProvider: FC<WithChildren> = ({ children }) => {
  const { parametros, query } = useParametrosIndicadores()

  const { isFetching, refetch, data } = useQuery(
    [QUERIES.INDICADORES_PERFORMANCE, query],
    () => getIndicadoresPerformance(parametros as ParametrosIndicadores),
    {
      enabled: Boolean(parametros),
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: showError,
    }
  )

  return (
    <QueryResponsePerformanceContext.Provider
      value={{
        isLoading: isFetching,
        refetch,
        singleResponse: data,
        query,
      }}
    >
      {children}
    </QueryResponsePerformanceContext.Provider>
  )
}

export const useQueryResponsePerformance = () => useContext(QueryResponsePerformanceContext)
